// removed by extract-text-webpack-plugin
module.exports = {"mobileIssueList":"Subscription__mobileIssueList--3bmjL"};


//////////////////
// WEBPACK FOOTER
// ./src/subscriptions/components/Subscription/Subscription.css
// module id = ./src/subscriptions/components/Subscription/Subscription.css
// module chunks = 2